import VerticalTabsDefaultProps from "segments/desktop/core-components/vertical-tabs/default-props";

export default {
  ...VerticalTabsDefaultProps
};